import { render, staticRenderFns } from "./contractFormComments.vue?vue&type=template&id=38de6588&"
import script from "./contractFormComments.vue?vue&type=script&lang=js&"
export * from "./contractFormComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports